import { AnimatedSection } from 'modules/Auth/components'
import { Container, Logo, CustomLogoImage } from './AuthHeader.styled'

type AuthHeaderProps = {
  logoUrl?: Nullable<string>
}

const AuthHeader: React.FC<AuthHeaderProps> = ({ logoUrl }) => {
  function renderLogo() {
    if (!logoUrl) return <Logo data-test='AuthHeaderLogo' />
    return <CustomLogoImage src={logoUrl} data-test='AuthHeaderLogo' />
  }

  return (
    <Container>
      <AnimatedSection animationDuration='.5s'>{renderLogo()}</AnimatedSection>
    </Container>
  )
}

export default AuthHeader
